import { immer } from 'zustand/middleware/immer'

import { UserInfoResponse } from '~/clients/derived-api-types'
import env from '~/env'

import { Slice } from '../store'

type State = {
    display_name: string | null
    username: string | null
    read_only: boolean
    issuer: UserInfoResponse['issuer'] | null
    apiAccessToken: string | null
    dipsApiAccessToken: string | null
    dipsApiAccessTokenIsFromPKCE: boolean
    idTokenPKCE?: string
}

const initialState: State = {
    display_name: null,
    username: null,
    read_only: false,
    issuer: null,
    apiAccessToken: null,
    dipsApiAccessToken: null,
    dipsApiAccessTokenIsFromPKCE: false,
    idTokenPKCE: undefined,
}

type Actions = {
    actions: {
        setDipsApiAccessToken: (args: {
            dipsApiAccessToken: State['dipsApiAccessToken']
            dipsApiAccessTokenIsFromPKCE: State['dipsApiAccessTokenIsFromPKCE']
            idTokenPKCE: State['idTokenPKCE']
        }) => void
        setAuth: (args: {
            display_name?: string | null
            username?: string | null
            read_only?: boolean
            accessToken: string | null
            issuer?: UserInfoResponse['issuer']
        }) => void
    }
}

export type UserSlice = {
    user: State & Actions
}

export const createUserSlice: Slice<UserSlice> = immer(set => ({
    user: {
        ...initialState,
        actions: {
            setDipsApiAccessToken: ({ dipsApiAccessToken, dipsApiAccessTokenIsFromPKCE, idTokenPKCE }) => {
                set(state => {
                    state.user.dipsApiAccessToken = dipsApiAccessToken
                    state.user.dipsApiAccessTokenIsFromPKCE = dipsApiAccessTokenIsFromPKCE
                    state.user.idTokenPKCE = idTokenPKCE
                })
            },
            setAuth: ({ display_name, username, read_only, accessToken, issuer }) => {
                set(state => {
                    state.user.apiAccessToken = accessToken
                    state.user.display_name = display_name ?? state.user.display_name
                    state.user.username = username ?? state.user.username
                    state.user.read_only = read_only ?? state.user.read_only
                    state.user.issuer = issuer ?? state.user.issuer

                    if (!env.VITE_PKCE_AUTHORIZE_URL) {
                        state.user.dipsApiAccessToken = accessToken
                        state.user.dipsApiAccessTokenIsFromPKCE = !accessToken
                    }
                })
            },
        },
    },
}))
